import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { CoverpathUtils } from '../../../../../coverpath-common/js/static/CoverpathUtils';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';

@Component({
    moduleId: module.id,
    selector: 'faq',
    templateUrl: './faq.component.html'
})
export class FaqComponent implements OnInit {
    controller;

    constructor(private amorphicService: AmorphicService, private route: ActivatedRoute, private router: Router) {
        this.controller = amorphicService.controller;
    }

    ngOnInit(): void {}

    scrollToElement(id: string) {
        CoverpathUtils.scrollToElement(id);
    }
}
